export const setSportId = (sportIds, item) => {
    return sportIds[item.sportId]
        ? item.sportId
        : "0";
};
//# sourceMappingURL=setSportId.js.map